function init_girlsuit(from_php){
    if(!from_php.girl_id){
        return false;
    }
    var main=$(".place.girlsuit");
    var cur_tab="",cur_type="",cosmetic_page=0;
    
    var girlName=$.takeGirlImage(from_php.girl_id);
    var semaphoreSuit= new mySemaphore();
    var girlMainView=main.find("#girlMainView");
    var girlObj=new girlSuitView(from_php.girl_id,from_php.active_obj);
    girlObj.makeView(girlMainView);
    
    var girlFighter=new girlFightView(from_php.girl_id,main.find("#pvpStatBoxJS"),from_php.fighterStat);
    girlFighter.start();
    
//    "1"=>array("name"=>"shirt","block"=>array("dress","corset","overall")),
//        "2"=>array("name"=>"shoes","block"=>array()),
//        "3"=>array("name"=>"bra","block"=>array("corset")),
//        "4"=>array("name"=>"dress","block"=>array("shirt","skirt","trousers","overall","corset")),
//        "5"=>array("name"=>"skirt","block"=>array("trousers","dress","overall")),
//        "6"=>array("name"=>"pants","block"=>array("tights_set")),
//        "7"=>array("name"=>"trousers","block"=>array("skirt","dress","tights_set","tights","overall")),
//        "8"=>array("name"=>"tights","block"=>array("trousers","tights_set","overall")),
//        "9"=>array("name"=>"tights_set","block"=>array("pants","tights","overall","trousers")),
//        "10"=>array("name"=>"corset","block"=>array("bra","shirt","dress","overall")),
//        "11"=>array("name"=>"overall","block"=>array("shirt","dress","skirt","trousers","tights","tights_set","corset"))
    
    
    
    var typeObjTypeId={
        "top":[1,3,4,10,11,12,13],
        "bottom":[5,6,7,8,9],
        "cap":[21,16,15,14],
        "shoe":[2],
        "extra":[20,19,18,17]
    };
    function postSuitAjax(to_send,fun_on_end){
        to_send=$.extend(to_send,{page:"girlsuit","girl_id":from_php.girl_id});
        if(semaphoreSuit.use()){
            $.mypost('/ajax',to_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                        from_php.have_arr=data.have_arr;
                        from_php.active_obj=data.active_obj;
                        from_php.cosmetic=data.cosmetic;
                        girlObj.updateActive(from_php.active_obj);
                        girlObj.makeView(girlMainView);
                        showTabCur();
                        semaphoreSuit.clear();
                        was_clear=1;
                        if(typeof fun_on_end!="undefined"){
                            fun_on_end(data);
                        }
                        if(typeof data.fighterStat!="undefined"){
                            girlFighter.update(data.fighterStat);
                        }
                        showCosmetic();
                    
                }
                if(!was_clear){
                    semaphoreSuit.clear();
                }
                
            },"json");
        }
    }
    function showBookConflict(suit_id,type_id){
        var book=main.find(".book.bookConflictSuit");
        book.bookUse("show");
        var conf_arr=girlObj.canWear(type_id,from_php.block_conf);
        var ctype_id,csuit_id,html="";
        var take_off=[];
        for(ctype_id in conf_arr){
            csuit_id=conf_arr[ctype_id];
            take_off.push(csuit_id);
            html+=
            '<div class="imageCont">'+
                '<div class="imageCustom" style="background-image:url('+girlObj.takeSuitIconPath(csuit_id)+'")></div>'+
            '</div>';
        }
        html+=
        '<div class="arrConf"></div>';
        html+=
        '<div class="imageCont">'+
            '<div class="imageCustom" style="background-image:url('+girlObj.takeSuitIconPath(suit_id)+'")></div>'+
        '</div>';
         book.find("#putRowsConfJS").html(html);
         book.find("#sendConflictJS").off("click").on("click",function(){
             postSuitAjax({"takeoff_arr":take_off,put_in:suit_id},function(){
                 book.bookUse("hide");
             });
         });
        //imageCont imageCustom
        
        //postSuitAjax({"takeoff_arr":[suit_id]});
        
        //sendConflictJS
    }
    function showBookBuy(suit_id,type_id){
        var conf;
        if(typeof from_php.stat[suit_id]=="undefined"){
            return false;
        }
        conf=from_php.stat[suit_id];
        var book=main.find(".book.bookBuySuit");
        book.bookUse("show");
        var hideCashObj=book.find(".hideCashJS");
        var premium=0;
        if(conf.cash>0){
            hideCashObj.show();
            book.find(".cashJSbut").attr("data-need",conf.cash+"c").updateButton().find(".in").html(cashFormat(conf.cash,2,10000));
            //premium_cost
            premium=Math.ceil(conf.cash/intval(from_php.premium_cost));
            premium=Math.min(from_php.premium_suit_cap,premium);
            book.find(".premiumJSbut").attr("data-premium",premium+"p").updateButton().find(".in").html(premium);
        }
        else{
            hideCashObj.hide();
            if(conf.premium){
                premium=conf.premium;
                book.find(".premiumJSbut").attr("data-premium",premium+"p").updateButton().find(".in").html(premium);
            }
        }
        book.find(".shOne.skillfight").attr("data-type",conf.skill_type_id).html("+"+conf.skill_bonus+"%");
        book.find(".imageCont .imageCustom").css("background-image","url("+_IMG_SERV+'/gfx/girlsuit/'+girlName+'/'+suit_id+'_ico.png)');
        var qobj={};
        qobj[type_id]=suit_id;
        var girlTmp=new girlSuitView(from_php.girl_id,qobj);
        girlTmp.makeView(book.find(".girlShow"));
        book.find(".cashJSbut").off("click").on("click",function(){
            postSuitAjax({buy_suit:suit_id,by_premium:0},function(){
               book.bookUse("hide"); 
            });
        });
        
        book.find(".premiumJSbut").off("click").on("click",function(){
            $.payByPremium(premium,function(){
                postSuitAjax({buy_suit:suit_id,by_premium:1},function(){
                    book.bookUse("hide"); 
                });
            });
        });
        
        //cashJSbut
    }
    function showTabShop(){
        var html="",i,bum;
        for(i in from_php.stat){
            bum=copyObj(from_php.stat[i]);
            if(in_array(bum.type_id,typeObjTypeId[cur_type]) && (bum.premium || bum.cash)){
            html+=
            '<div class="cell" data-suit_id="'+bum.suit_id+'" data-type_id="'+bum.type_id+'">'+
                '<div class="img" style="background-image:url('+_IMG_SERV+'/gfx/girlsuit/'+girlName+'/'+bum.suit_id+'_ico.png)"></div>';
                if(in_array(bum.suit_id,from_php.have_arr)){
                html+=
                    '<div class="haveRow">'+
                        '<div class="textfill center">'+
                            '<span>'+from_php.langs.have_it+'</span>'+
                        '</div>'+
                    '</div>';
                }
                else if(bum.premium){
                html+=
                    '<div class="formSubmit qpremium">'+
                        '<div class="in">'+bum.premium+'</div>'+
                    '</div>';
                }
                else if(bum.cash){
                html+=
                    '<div class="formSubmit qcash">'+
                        '<div class="in">'+cashFormat(bum.cash,2,10000)+'</div>'+
                    '</div>';    
                }
            html+=
            '</div>';
            }
        }
        if(html!=""){
            html="<div class='wrapJS'><div class='flexList'>"+html+"</div></div>";
            main.find("#mainSuit .itemCont").html(html).find(".flexList").blankCell().closest(".wrapJS").
                myPageSelector({width:348,height:450}).find(".textfill").textfill();
            main.find("#mainSuit .itemCont .cell[data-suit_id]").click(function(){
                var th=$(this);
                if(!th.find(".haveRow").length){
                    showBookBuy(intval(th.attr("data-suit_id")),intval(th.attr("data-type_id")));
                }
                return false;
            });
        }
        else{
            main.find("#mainSuit .itemCont").html(
                "<div class='noneItems'>"+
                    "<div class='qtext'>"+from_php.lang.COMING_SOON_SUIT+"</div>"+
                "</div>"
            );
        }
        
            
    }
    function showTabOwn(){
        var html="",i,bum,stat,suit_id,can_wear,is_active;
        if(from_php.have_arr.length){
            for(i in from_php.have_arr){
                suit_id=from_php.have_arr[i];
                stat=copyObj(from_php.stat[suit_id]);
                //from_php.stat[i]
                if(in_array(stat.type_id,typeObjTypeId[cur_type])){
                    can_wear=0;
                    is_active=girlObj.isWearing(suit_id,stat.type_id);
                    if(girlObj.canWear(stat.type_id,from_php.block_conf)===true){
                        can_wear=1;
                    }

                html+=
                '<div class="cell" data-suit_id="'+stat.suit_id+'" data-can_wear="'+can_wear+'" data-type_id="'+stat.type_id+'" data-active="'+is_active+'">'+
                    '<div class="img" style="background-image:url('+girlObj.takeSuitIconPath(suit_id)+')">';
                        html+='<div class="event_type" data-type="'+stat.event_type+'"></div>';
            
                    html+=
                    '</div>';
                    if(!can_wear){
                    html+=
                        '<div class="lockIt"></div>';
                    }
                    html+=
                        '<div class="shOne skillfight" data-type="'+stat.skill_type_id+'">+'+stat.skill_bonus+'%</div>';
                
                html+=
                '</div>';
                }
            }
        }    
        if(html!=""){    
            html="<div class='wrapJS'><div class='flexList'>"+html+"</div></div>";
            main.find("#mainSuit .itemCont").html(html).find(".flexList").blankCell().closest(".wrapJS").
                myPageSelector({width:348,height:450}).find(".textfill").textfill();
            main.find("#mainSuit .itemCont .cell[data-suit_id]").click(function(){
                var th=$(this),type_id=intval(th.attr("data-type_id")),suit_id=intval(th.attr("data-suit_id")),
                can_wear=intval(th.attr("data-can_wear")),is_active=intval(th.attr("data-active"));
                if(is_active){
                    //zdjąc
                     postSuitAjax({"takeoff_arr":[suit_id]});
                }
                else{
                    if(can_wear){
                        //zalozyc
                        postSuitAjax({"put_in":suit_id});
                    }
                    else{
                       //popup    
                       showBookConflict(suit_id,type_id);
                    }
                }

                return false;
            });
            
        }   
        else{
            var tmp_text=from_php.lang.BUTTON_NONE_OWN;
            main.find("#mainSuit .itemCont").html(
                "<div class='noneItems'>"+
                    "<div class='formSubmit' id='goToTabShopJS'>"+
                        "<div class='in'>"+tmp_text+"</div>"+
                    "</div>"+
                "</div>")
                .find("#goToTabShopJS").click(function(){
                    main.find(".tabsWrap .tab[data-type='shop']").trigger("click");
                    return false;
                });
        }
    }
    function showTabCur(){
        if(cur_tab=="shop"){
            showTabShop();
        }
        if(cur_tab=="own"){
            showTabOwn();
        }
        main.find("#mainSuit .tabsWrap .textfill").textfill();
    }
    function initTabs(){
        var triggerTab="shop";
        if(from_php.have_arr.length){
            triggerTab="own";
        }
        main.find(".tabsWrap .tab").click(function(){
            main.find(".tabsWrap .tab").removeClass("active");
            var th=$(this);
            th.addClass("active");
            cur_tab=th.attr("data-type");
            main.find("#mainSuit").attr("data-type",cur_tab);
            showTabCur();
            return false;
        }).filter("[data-type='"+triggerTab+"']").trigger("click");
    }
    function initIcons(){
        main.find(".iconList .icon").click(function(){
            main.find(".iconList .icon").removeClass("active");
            var th=$(this);
            th.addClass("active");
            cur_type=th.attr("data-type");
            showTabCur();
            return false;
        }).eq(0).trigger("click");
    }
    function cantCosmetic(th,cosmetic_id){
        var timeIndex=th.takeObjTimeHanderIndex(_moduleTimeHandler);
        if(!_moduleTimeHandler.isIndexSet(timeIndex)){
            var step=0,step_max=40,dir=1;
            //spare_text
            var text=from_php.cosmetic.count_text;
            if(from_php.cosmetic.user[cosmetic_id].howmany==0){
                text=from_php.cosmetic.spare_text;
            }
            
            
            th.append("<div class='needDone'><div>"+text+"</div></div>");
            var text=th.find(".needDone"),showHide=th.find(".img,.howmanyWrap");
            showHide.hide();
//            return false;
            _moduleTimeHandler.set(timeIndex,function(){
                step+=dir;
                if(step>=step_max){
                    dir=-1;
                }
                if(step<=0){
                    _moduleTimeHandler.clear(timeIndex);
                }
                else if(dir==-1){
                    text.css("opacity",step/step_max)
                }
            },50,function(){
                text.remove();
                showHide.show();
            });
        }
    }
    function showCosmetic(){
        var html="",i,bum,row,is_active;
        var cosmeticWin=main.find("#tabCosmetic");
        if(from_php.cosmetic.user){
            var cosmetic_user=from_php.cosmetic.user,cosmetic_girl=from_php.cosmetic.girl;
            var hover_active=0;
            var count_max=from_php.cosmetic.count_max;
            for(i in cosmetic_user){
                row=cosmetic_user[i];
                hover_active=0;
                if(cosmetic_girl.length<count_max){
                    hover_active=1;
                }
                if(row.howmany==0){
                     hover_active=0;
                }
                is_active=0;
                if(in_array(row.cosmetic_id,cosmetic_girl)){
                    is_active=1;
                    hover_active=1;
                }
                
                html+=
                '<div class="cell" data-cosmetic_id="'+row.cosmetic_id+'" data-active="'+is_active+'" data-have_hover="'+hover_active+'">'+
                    '<div class="img" style="background-image:url('+_IMG_SERV+'/gfx/cosmetic/'+row.cosmetic_id+'.png?4)"></div>'+
                    '<div class="howmanyWrap"><div class="val">x'+row.howmany+'</div></div>'+
                    '<div class="shOne skillfight" data-type="'+row.skill_type_id+'">+'+row.skill_bonus+'%</div>'+
                '</div>';
            }
        }    
        if(html!=""){    
            cosmeticWin.show();
            html="<div class='wrapJS'><div class='flexList'>"+html+"</div></div>";
            cosmeticWin.find(".itemCont").html(html).find(".flexList").blankCell().closest(".wrapJS").
            myPageSelector({width:232,height:280,page:cosmetic_page}).on("change",function(e,data){
                cosmetic_page=data["data-page"];
            });
        
        
            cosmeticWin.find(".itemCont .cell[data-cosmetic_id]").click(function(){
                var th=$(this),cosmetic_id=intval(th.attr("data-cosmetic_id")),
                is_active=intval(th.attr("data-active")),hover_active=intval(th.attr("data-have_hover"));
                if(is_active){
                    //zdjąc
                    postSuitAjax({"takeoff_cosmetic":cosmetic_id});
                }
                else{
                    if(hover_active){
                        postSuitAjax({"putin_cosmetic":cosmetic_id});
                    }
                    else{
                        cantCosmetic(th,cosmetic_id);
                    }
                }

                return false;
            });
            
        }   
        else{
            cosmeticWin.find(".dontHave").show();
        }
    }
    initTabs();
    initIcons();
    showTabCur();
    showCosmetic();
}